/**
 * 帮助
 */
import { Helper } from "../views/index.js";

export const helpMethods = {
  methods: {
    toHelp(index) {
      this.$router.push({
        name: Helper.name,
        query: {
          index: index
        }
      });
    }
  }
};
